import store from '@/store';
export const option = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    editBtnText: "修改数量",
    editTitle: "修改数量",
    addBtn: false,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: false ,
    menu:true,
    indexLabel: '序号',
    selection: true,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "进件编号",
            prop: "businessCode",
            display: false,
            search: true,
            searchOrder: 444,
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: true,
            searchPlaceholder: "请输入租赁人",
            display: false,
            searchOrder: 777,
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            multiple: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            display: false,
            search: true,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes,
            searchOrder: 888,
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            span: 24,
            search:true,
            display: false,
            searchOrder: 666,
        },
        {
            label: "id",
            prop: "id",
            display: false,
            hide: true,
        },
        {
            label: "产品类型",
            prop: "rentType",
            display: false,
            type: "select",
            hide: false,
            dicData: store.getters.porductTypes

        },
        {
            label: "库位",
            prop: "storageLocationManagementName",
            span: 24,
            display: false,
            hide: true,
        },
        {
            label: "库位",
            prop: "locationIdList",
            span: 24,
            hide: true,
            search: true,
            display: false,
            type: "select",
            searchClearable: true,
            filterable: true,
            dicData: [],
            searchOrder: 555,
            props: {
                label: "storageLocation",
                value: "id"
            }
        },

        {
            label: "入库时间",
            prop: "warehouseEntryTime",
            span: 24,
            display: false,
            hide: true,
        },
        {
            label: "出库时间",
            prop: "outEntryTime",
            span: 24,
            display: false,
            hide: true,
        },
        {
            label: "数量",
            prop: "amount",
            span: 24,
            rules: [{
                    required: true,
                    message: "请输入数量",
                    trigger: "blur",
                },
                {
                    validator: (rule, value, callback) => {
                        if (value) {
                            // let reg = /^[1-9]\d{0,1}$$/; // 只能输入1-99的整数
                            let reg = /^(0|[1-9]\d?)$/; // 只能输入0-99的整数
                            if (!reg.test(value)) {
                                callback(new Error('请输入0-99的整数'));
                            } else {
                                callback();
                            }
                        } else {
                            callback(new Error('请输入数字'))
                        }
                    },
                    trigger: 'blur'
                }
            ],
        },
        // {
        //   label: "申请人",
        //   prop: "createUser",
        //   span: 24,
        //   display: false,
        //   hide: false,
        // },
        {
          label: "申请时间",
          prop: "createTime",
          span: 24,
          display: false,
          hide: false,
        },
        {
            label: "申请人",
            prop: "createUserName",
            span: 24,
            display: false,
            hide:false,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            span: 24,
            display: false,
        },
        {
          label: "备注",
          prop: "remark",
          span: 24,
          display: false,
          hide:true,
        },
    ],
}
